/* eslint-disable eqeqeq */
import {
  CmpSelectField,
  CmpTypographyField,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { dcrequest_DCItemPriority_GETROW } from "../../Server/ApiV2";
import { useSelector } from "react-redux";
import { GetGitterColumns } from "../../Utility/Utilitys";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetLocation } from "./DCItemsPriorityAction";
import "./DCItemsPriority.css";
//EXPORT

const Gridcolumns = [
  {
    field: "B_SrNo",
    headerName: "Sr.No  ",
    width: 50,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_ItmCd",
    headerName: "Item.Code",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "itmName",
    headerName: "Name",
    width: 300,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "B_Stk_Days",
    headerName: "Days",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_Sfty_Days",
    headerName: "Sfty",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_Cnsm",
    headerName: "Consm.",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "BalQty",
    headerName: "Bal.Qty ",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_Stock_DC",
    headerName: "DC.Stk",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_PU_Unit",
    headerName: "Unit",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_PU_Stock",
    headerName: "Stock",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_Projection",
    headerName: "Proj",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_PU_ROP",
    headerName: "ROP",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_PU_ROQ",
    headerName: "Req.Qty",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_Priority",
    headerName: "Priority",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_DC_RSP_Final",
    headerName: "DC-Cost",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_RSP",
    headerName: "RSP",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "B_GPPerc",
    headerName: "GP.%",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
];

export default function DCItemsPriority() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const [sLocation, setLocation] = useState(vRdxuserLoc);
  const [sHeadObj, setHeadObj] = useState({
    location: "",
    priority: "",
  });

  const [checkedItems, setCheckedItems] = useState({
    P1: true,
    P2: false,
    P3: false,
    P4: false,
  });

  const handleChange = (event) => {
    setCheckedItems((obj) => ({
      ...obj,
      [event.target.name]: event.target.checked,
    }));
  };

  const [sGridrows, setGridrows] = useState([]);
  const [sGridcolumnsDCREQT, setGridcolumnsDCREQT] = useState([]);

  const fLocationSelect = (e) => {
    setHeadObj((obj) => ({
      ...obj,
      location: e.target.value,
    }));
  };

  const fReset = (e) => {
    setCheckedItems((obj) => ({
      ...obj,
      P1: true,
      P2: false,
      P3: false,
      P4: false,
    }));
    setHeadObj((obj) => ({
      ...obj,
      location: sLocation[0].UID,
    }));
    setGridrows([]);
  };

  const fViewReport = async () => {
    const selectedKeys = Object.keys(checkedItems).filter(
      (key) => checkedItems[key]
    );
    let DCItemPriorityObj = {
      v_A_Loc: sHeadObj.location,
      v_Priority: selectedKeys.join(","),
    };
    const iResp = await dcrequest_DCItemPriority_GETROW(DCItemPriorityObj);
    if (iResp?.status == 200) {
      if (iResp?.data?.ResultSet?.length > 0) {
        let RespGrid = iResp?.data?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setGridrows(RespGrid);
      } else {
        setGridrows([]);
      }
    }
  };
  const fLoad = async () => {
    let locationResp = await GetLocation(setLocation);
    if (locationResp?.length > 0) {
      setHeadObj((obj) => ({
        ...obj,
        location: locationResp[0].UID,
      }));
    }
  };
  useEffect(() => {
    fLoad();
  }, []);

  useEffect(() => {
    GetGitterColumns(
      setGridcolumnsDCREQT,
      "DCItemPriority_Summary",
      Gridcolumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={vMediaQuery ? "container-fluid mt-5" : "container-fluid my-5"}
    >
      <div className="Instant-picking-head">
        <Grid container spacing={2}>
          <Grid
            item 
            md={6}
            xs={12}
            className="bintransfer-data-date d-flex align-items-center"
          >
            <Grid container spacing={2}>
              <Grid
                item
                lg={3}
                md={3}
                xs={3}
                className="bintransfer-data-date d-flex align-items-center"
              >
                <CmpTypographyField xcomponent={"span"} xText={"Location"} />
              </Grid>
              <Grid
                item
                lg={9}
                md={5}
                xs={9}
                className="bintransfer-data-date d-flex align-items-center"
              >
                <CmpSelectField
                  xLabelText="Location"
                  xValue={sHeadObj.location}
                  xOnChange={(event) => fLocationSelect(event)}
                  xName={"location"}
                  xData={sLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item 
            md={6}
            xs={12}
            className="bintransfer-data-date d-flex align-items-center"
          >
            <Grid container spacing={2}>
              <Grid
                item
                lg={2}
                md={3}
                xs={3}
                className="bintransfer-data-date d-flex align-items-center"
              >
                <CmpTypographyField xcomponent={"span"} xText={"Priority"} />
              </Grid>
              <Grid
                item
                lg={9}
                md={9}
                xs={9}
                className="bintransfer-data-date d-flex align-items-center justify-content-around"
              >
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedItems["P1"]}
                        onChange={handleChange}
                        name="P1"
                      />
                    }
                    label="P1"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedItems["P2"]}
                        onChange={handleChange}
                        name="P2"
                      />
                    }
                    label="P2"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedItems["P3"]}
                        onChange={handleChange}
                        name="P3"
                      />
                    }
                    label="P3"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedItems["P4"]}
                        onChange={handleChange}
                        name="P4"
                      />
                    }
                    label="P4"
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          className={
            vMediaQuery ? "justify-content-center" : " justify-content-end"
          }
        >
          <Grid
            item
            lg={2}
            md={2.5}
            xs={4}
            className="bintransfer-data-date d-flex align-items-center my-2"
          >
            <CmpButton
              xbtnName="View Report"
              xOnClick={fViewReport}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
            />
          </Grid>
          <Grid
            item
            lg={2}
            md={2}
            xs={4}
            className="bintransfer-data-date d-flex align-items-center"
          >
            <CmpButton
              xbtnName="Reset"
              xOnClick={fReset}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
            />
          </Grid>
        </Grid>

        <Box sx={{ height: vMediaQuery ? "60vh" : "70vh", width: "100%" }}>
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sGridrows}
            columns={sGridcolumnsDCREQT}
            hideFooter={sGridrows.length < 100}
            components={{
              Toolbar: GridToolbar,
            }}
          />
        </Box>
      </div>
    </div>
  );
}
